import classNames from "classnames";
import Modal from "../../../../../components/common/Modal";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import Dropdown from "./DropDown";
import {
  shippingCompanyOptions,
  cashInOptions,
  categoryOptions,
  operationalStatusOptions,
  operationalTypeOptions,
  escalationOptions,
  operationResultOptions,
  commisionBearerOptions,
  cashOutOptions,
  cashOutOutSystemOptions,
  cashOutOutTypeOptions,
} from "./constants";
import { useContext, useState } from "react";
import FloatingTextarea from "../FloatingTextArea";
import { ContractContext } from "../../../../../providers/contract";
import PrimaryButton from "../../../../../components/common/PrimaryButton";
import { editOperationMetadata } from "../../../../../setup/api/services/contract";
import Spinner from "../../../../../components/common/Spinner";

interface IEditDataModalProps {
  handleClose: () => void;
  modalOpen: boolean;
}

const EditDataModal = ({ handleClose, modalOpen }: IEditDataModalProps) => {
  const { t } = useTranslation();
  const { contract } = useContext(ContractContext);
  const [shippingCompany, setShippingCompany] = useState<string>(
    contract?.operationsMetaData?.shippingCompany || ""
  );
  const [cashIn, setCashIn] = useState<string>(
    contract?.operationsMetaData?.cashIn || ""
  );
  const [category, setCategory] = useState<string>(
    contract?.operationsMetaData?.category || ""
  );
  const [operationalStatus, setOperationalStatus] = useState<string>(
    contract?.operationsMetaData?.operationStatus || ""
  );
  const [operationalType, setOperationalType] = useState<string>(
    contract?.operationsMetaData?.operationalType || ""
  );
  const [escalation, setEscalation] = useState<string>(
    contract?.operationsMetaData?.escalation || ""
  );
  const [operationResult, setOperationResult] = useState<string>(
    contract?.operationsMetaData?.operationResult || ""
  );
  const [commisionBearer, setCommisionBearer] = useState<string>(
    contract?.operationsMetaData?.commisionBearer || ""
  );
  const [cashOut, setCashOut] = useState<string>(
    contract?.operationsMetaData?.cashOut || ""
  );
  const [cashOutOutSystem, setCashOutOutSystem] = useState<string>(
    contract?.operationsMetaData?.cashOutOutSystem || ""
  );
  const [cashOutOutType, setCashOutOutType] = useState<string>(
    contract?.operationsMetaData?.cashOutOutType || ""
  );
  const [comments, setComments] = useState<string>(
    contract?.operationsMetaData?.comments || ""
  );
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    await editOperationMetadata(contract?.id || "", {
      cashIn: cashIn,
      category: category,
      operationStatus: operationalStatus,
      operationalType: operationalType,
      escalation: escalation,
      operationResult: operationResult,
      commisionBearer: commisionBearer,
      shippingCompany: shippingCompany,
      cashOut: cashOut,
      cashOutOutSystem: cashOutOutSystem,
      cashOutOutType: cashOutOutType,
      comments: comments,
    });
    setLoading(false);
    window.location.reload();
  };

  return (
    <Modal
      visible={modalOpen}
      onCancel={handleClose}
      customModalClassName={styles.modalContainer}>
      <div className={classNames(styles.container)}>
        <h1 className={styles.title}>{t("lbl_operation_metadata")}</h1>
        <div className={styles.content}>
          <Dropdown
            options={categoryOptions}
            label={t("lbl_category")}
            onChange={(value) => {
              setCategory(value);
            }}
            value={category}
          />

          <Dropdown
            options={operationalStatusOptions}
            label={t("lbl_operational_status")}
            onChange={(value) => {
              setOperationalStatus(value);
            }}
            value={operationalStatus}
          />

          <Dropdown
            options={cashInOptions}
            label={t("lbl_payment_method")}
            onChange={(value) => {
              setCashIn(value);
            }}
            value={cashIn}
          />

          <Dropdown
            options={operationalTypeOptions}
            label={t("lbl_operational_type")}
            onChange={(value) => {
              setOperationalType(value);
            }}
            value={operationalType}
          />

          <Dropdown
            options={escalationOptions}
            label={t("lbl_escalation")}
            onChange={(value) => {
              setEscalation(value);
            }}
            value={escalation}
          />

          <Dropdown
            options={operationResultOptions}
            label={t("lbl_operation_result")}
            onChange={(value) => {
              setOperationResult(value);
            }}
            value={operationResult}
          />

          <Dropdown
            options={commisionBearerOptions}
            label={t("lbl_commission_bearer")}
            onChange={(value) => {
              setCommisionBearer(value);
            }}
            value={commisionBearer}
          />

          <Dropdown
            options={shippingCompanyOptions}
            label={t("lbl_shipping_company")}
            onChange={(value) => {
              setShippingCompany(value);
            }}
            value={shippingCompany}
          />

          <Dropdown
            options={cashOutOptions}
            label={t("lbl_transfer")}
            onChange={(value) => {
              setCashOut(value);
            }}
            value={cashOut}
          />

          <Dropdown
            options={cashOutOutSystemOptions}
            label={t("lbl_cash_out_system")}
            onChange={(value) => {
              setCashOutOutSystem(value);
            }}
            value={cashOutOutSystem}
          />

          <Dropdown
            options={cashOutOutTypeOptions}
            label={t("lbl_cash_out_type")}
            onChange={(value) => {
              setCashOutOutType(value);
            }}
            value={cashOutOutType}
          />

          <FloatingTextarea
            label="ملاحظات"
            value={comments}
            onChange={setComments}
            rows={5}
            dir="rtl"
            customClass={styles.customTextArea}
          />

          <PrimaryButton
            disabled={loading}
            type="submit"
            onClick={handleSubmit}
            style={{
              width: "100%",
              height: "44px",
              minHeight: "44px",
              borderRadius: "8px",
              background: loading ? "#E2E5EE" : "#0D44AD",
              textAlign: "center",
              whiteSpace: "nowrap",
              fontSize: "1rem",
              lineHeight: "100%",
              fontWeight: 600,
              marginTop: "6px",
            }}>
            {loading ? <Spinner /> : t("lbl_edit_profile_save_btn")}
          </PrimaryButton>
        </div>
      </div>
    </Modal>
  );
};

export default EditDataModal;
